module.exports = __webpack_public_path__ + "img/fontsForEngravings.5e7cd2b.webp";